module.exports = __webpack_public_path__ + "img/04_RESGUARDA.b6521ed9.png";